import { BridgeComponent } from '@hotwired/hotwire-native-bridge'

export default class extends BridgeComponent {
  static component = 'push-prompt'
  static targets = ['badge', 'chevron']
  static values = {
    enabledText: String,
    disabledText: String,
  }
  static classes = ['enabled', 'disabled']

  connect() {
    super.connect()
    this.send('connect', {}, ({ data }) => {
      this.updateUI(data)
      this.pushStatus = data
    })
  }

  activate() {
    if (!this.pushStatus || this.pushStatus.enabled) return

    if (this.pushStatus.canRequest) {
      this.send('requestPermission', {}, ({ data }) => {
        this.updateUI(data)
        this.pushStatus = data
      })
    } else {
      this.send('openSettings')
    }
  }

  updateUI(data) {
    if (!this.hasBadgeTarget) return

    if (data.enabled) {
      this.badgeTarget.textContent = this.enabledTextValue
      this.badgeTarget.className = this.enabledClasses.join(' ')
      this.element.removeAttribute('role')
      if (this.hasChevronTarget) this.chevronTarget.classList.add('d-none')
    } else {
      this.badgeTarget.textContent = this.disabledTextValue
      this.badgeTarget.className = this.disabledClasses.join(' ')
      this.element.setAttribute('role', 'button')
      if (this.hasChevronTarget) this.chevronTarget.classList.remove('d-none')
    }
  }
}
